module.exports = __webpack_public_path__ + "static/3-1df7c4132ad5f0a54cc7ba7b301a9bbc.png";